{
  "cycle.entite.organisation_cles_signature": "Clés de signature de l’organisation",
  "cycle.entite.organisation_webhook_livraisons": "Livraisons des webhooks de l’organisation",
  "cycle.entite.organisation_webhooks": "Webhooks de l’organisation",
  "journalAudit.action.org.signing_key.registered": "Clé de signature enregistrée",
  "journalAudit.action.org.signing_key.removed": "Clé de signature retirée",
  "journalAudit.action.org.signing_key.replaced": "Clé de signature remplacée",
  "journalAudit.action.org.webhook.created": "Webhook de l’organisation créé",
  "journalAudit.action.org.webhook.deleted": "Webhook de l’organisation supprimé",
  "journalAudit.action.org.webhook.disabled": "Webhook de l’organisation désactivé",
  "journalAudit.action.org.webhook.enabled": "Webhook de l’organisation activé",
  "journalAudit.action.org.webhook.secret_rotated": "Secret de signature d’un webhook renouvelé",
  "journalAudit.action.org.webhook.updated": "Webhook de l’organisation modifié"
}
